/* =============================================
   RVRN VIP CREDITS CALCULATOR — JS (deferred)
   Real-time calculation engine
   DOM contract: data-* attributes (see liquid)
   ============================================= */
;(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rvrn-vip-credits-calculator').forEach(function (section) {
      var tierBtns = section.querySelectorAll('[data-tier-group] button[data-tier-id]');
      var amountInput = section.querySelector('[data-amount-input]');
      var amountWrap = amountInput ? amountInput.closest('.rvrn-vip-credits-calculator__amount') : null;
      var bonusChecks = section.querySelectorAll('input[data-bonus-id]');
      var tierRows = section.querySelectorAll('[data-tier-result]');
      var bonusResultsEl = section.querySelector('[data-bonus-results]');
      var totalEl = section.querySelector('[data-total-credits]');
      var totalLabelEl = section.querySelector('[data-total-label]');
      var equivalentEl = section.querySelector('[data-total-equivalent]');
      var ctaTierEl = section.querySelector('[data-cta-tier]');

      // Parse data-exchanges: "100|text,500|text"
      var exchangeExamples = [];
      (section.getAttribute('data-exchanges') || '').split(',').forEach(function (entry) {
        if (!entry) return;
        var parts = entry.split('|');
        if (parts.length >= 2) {
          exchangeExamples.push({ threshold: parseFloat(parts[0]) || 0, text: parts.slice(1).join('|') });
        }
      });
      exchangeExamples.sort(function (a, b) { return a.threshold - b.threshold; });

      // State
      var activeTierId = null;
      var activeTierName = null;
      var activeTierRate = null;

      function syncInitialTier() {
        var btn = section.querySelector('[data-tier-group] button.is-active') || tierBtns[0];
        if (btn) {
          activeTierId = btn.getAttribute('data-tier-id');
          activeTierName = btn.getAttribute('data-tier-name');
          activeTierRate = btn.getAttribute('data-tier-rate');
        }
      }
      syncInitialTier();

      // Helper: parse rate string like "5%" to 0.05
      function parseRate(rateStr) {
        if (!rateStr) return 0;
        return parseFloat(String(rateStr).replace('%', '').trim()) / 100;
      }

      // Helper: parse bonus value.
      // Schema bonus_value is always a percentage ("5", "10", "20" or "5%").
      // Treat plain numbers as percentages too (÷100) so they aren't applied as raw multipliers.
      function parseBonusValue(valueStr) {
        if (!valueStr) return 0;
        var raw = parseFloat(String(valueStr).replace('%', ''));
        if (isNaN(raw)) return 0;
        return raw / 100;
      }

      // Helper: format USD with $ prefix, always 2 decimal places
      function formatUSD(num) {
        return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      // Helper: get exchange text by threshold
      function getExchangeText(total) {
        if (!exchangeExamples.length) return '';
        var best = exchangeExamples[0];
        for (var i = 0; i < exchangeExamples.length; i++) {
          if (total >= exchangeExamples[i].threshold) {
            best = exchangeExamples[i];
          }
        }
        return best.text;
      }

      function escapeHTML(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
      }

      // Core: recalculate
      function recalculate() {
        var amount = parseFloat(amountInput ? amountInput.value : '') || 0;
        if (isNaN(amount) || amount < 0) amount = 0;

        var rate = parseRate(activeTierRate);
        var tierCredits = amount * rate;

        // All tier amounts for display
        var tierAmounts = {};
        tierBtns.forEach(function (btn) {
          tierAmounts[btn.getAttribute('data-tier-id')] = amount * parseRate(btn.getAttribute('data-tier-rate'));
        });

        // Bonuses: each block carries its own "base from Purchase Amount" toggle (data-bonus-base-from-purchase).
        // Default (no toggle / off) = base = active tier result (tierCredits). When on = base = Purchase Amount (amount).
        var bonusTotal = 0;
        var bonusDetails = [];
        bonusChecks.forEach(function (checkbox) {
          if (checkbox.checked) {
            var bonusType = checkbox.getAttribute('data-bonus-type');
            var bonusValue = parseBonusValue(checkbox.getAttribute('data-bonus-value'));
            var bonusLabel = checkbox.getAttribute('data-bonus-label');
            var bonusAmount = 0;

            if (bonusType === 'amount') {
              bonusAmount = bonusValue;
            } else {
              // percentage / self_purchase / fallback: base per-block toggle
              var baseFromPurchase = checkbox.getAttribute('data-bonus-base-from-purchase') === 'true';
              var bonusBase = baseFromPurchase ? amount : tierCredits;
              bonusAmount = bonusBase * bonusValue;
            }

            bonusTotal += bonusAmount;
            bonusDetails.push({ label: bonusLabel, amount: bonusAmount });
          }
        });

        var grandTotal = tierCredits + bonusTotal;

        // Tier rows: highlight active + update amounts
        tierRows.forEach(function (row) {
          var id = row.getAttribute('data-tier-result');
          row.classList.toggle('is-active', id === activeTierId);
          var creditEl = row.querySelector('[data-tier-credit]');
          if (creditEl && tierAmounts[id] !== undefined) {
            creditEl.textContent = formatUSD(tierAmounts[id]);
          }
        });

        // Bonus details
        if (bonusResultsEl) {
          bonusResultsEl.innerHTML = bonusDetails.length
            ? bonusDetails.map(function (bd) {
                return '<div><span>+ ' + escapeHTML(bd.label) + '</span><strong>+' + formatUSD(bd.amount) + '</strong></div>';
              }).join('')
            : '';
        }

        // Total
        if (totalEl) totalEl.textContent = formatUSD(grandTotal);
        if (totalLabelEl && activeTierName) {
          totalLabelEl.textContent = 'Total as ' + activeTierName + ' (' + (activeTierRate || '') + ')';
        }

        // Exchange / equivalent
        if (equivalentEl) {
          equivalentEl.textContent = getExchangeText(grandTotal) || '';
        }

        // CTA tier name
        if (ctaTierEl) {
          ctaTierEl.textContent = activeTierName || 'VIP';
        }
      }

      // Tier button click
      tierBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          tierBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          activeTierId = btn.getAttribute('data-tier-id');
          activeTierName = btn.getAttribute('data-tier-name');
          activeTierRate = btn.getAttribute('data-tier-rate');
          recalculate();
        });
      });

      // Amount input
      if (amountInput) {
        amountInput.addEventListener('input', function () {
          var raw = this.value;
          // 不允许 0 作为数字的第一个字符（除非 "0.x" 小数形式）
          if (raw.length > 1 && raw.charAt(0) === '0' && raw.charAt(1) !== '.') {
            raw = raw.replace(/^0+/, '') || '0';
            this.value = raw;
          }
          var val = parseFloat(raw);
          if (isNaN(val) || val < 0) {
            this.value = '0';
          }
          recalculate();
        });

        amountInput.addEventListener('focus', function () {
          if (amountWrap) amountWrap.classList.add('is-hovered');
          // 聚焦且值为 0 时清空，避免 0 停留在输入框首位，便于输入真实数字
          if (this.value === '0' || this.value === '0.') {
            this.value = '';
          }
        });
        amountInput.addEventListener('blur', function () {
          if (amountWrap) amountWrap.classList.remove('is-hovered');
          // 失去焦点且无数据时自动填 0
          if (this.value === '' || isNaN(parseFloat(this.value))) {
            this.value = '0';
          }
          recalculate();
        });
      }

      if (amountWrap) {
        amountWrap.addEventListener('mouseenter', function () {
          amountWrap.classList.add('is-hovered');
        });
        amountWrap.addEventListener('mouseleave', function () {
          amountWrap.classList.remove('is-hovered');
        });
      }

      // Bonus checkboxes
      bonusChecks.forEach(function (checkbox) {
        checkbox.addEventListener('change', recalculate);
      });

      // Initial calculation
      recalculate();
    });
  });
})();
